module.exports = __webpack_public_path__ + "static/assignment_1-ea0b552d1f6083fe1a6a449ad234aed9.gif";